<template>
    <el-dialog
        title="验证"
        :visible.sync="show"
        width="660px"
        @close="handleClose">
        <div class="validate-qrcode-pop-wrap">
            <img class="qrcode-img" :src="imgUrl" alt="">
            <p class="tip-text">请用手机扫描上方二维码进行人脸识别验证</p>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            },
            imgUrl: {
                type: String,
                default: ''
            }
        },
        watch: {
            value(nval){
                this.show = nval
            }
        },  
        data(){
            return {
                show: false,
                // qrcode: 'https://pic.3gbizhi.com/uploads/20240617/cd97bed6c27be66a5697a2362437d5e5.jpg'
            }
        },
        methods: {
            handleClose() {
                this.$emit('input', false)
            },
        }
    }
</script>

<style lang="less" scoped>
.validate-qrcode-pop-wrap{
    display: flex;
    flex-direction: column;
    align-items: center;
    .qrcode-img{
        min-height: 300px;
        width: 360px;
        object-fit: contain;
    }
    .tip-text{
        font-size: 16px;
        margin-top: 20px;
    }
}
</style>